import React, { memo, useEffect, useMemo, useState } from 'react'
import TableComponent from '../../components/Common/TableComponent'
import DashboardLayout from '../../layouts/DashboardLayout'
import { Helmet } from 'react-helmet'
import PageTitle from '../../components/PageTitle'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import { Button, message, Modal, Popconfirm, Select, Tooltip } from 'antd'
import {
  EditOutlined,
} from '@ant-design/icons'
import { TableComponentCustorm } from './WorkSchedulePersonalStyle'
import WorkSchedulePersonalStore from '../../stores/WorkSchedulePersonalStore'
import { withRouter } from 'react-router-dom/cjs/react-router-dom'
import { inject, observer } from 'mobx-react'
const { Option } = Select

const WorkSchedulePersonal = props => {
  const { authenticationStore } = props
  const formatDate = date => {
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    return `${day}/${month}/${year}`
  }

  const getWeekOfDate = inputDate => {
    const year = inputDate.getFullYear()
    let firstMonday = new Date(year, 0, 1)

    while (firstMonday.getDay() !== 1) {
      firstMonday.setDate(firstMonday.getDate() - 1)
    }

    let currentWeekStart = new Date(firstMonday)
    let weekNumber = 1

    while (true) {
      let weekStartDate = new Date(currentWeekStart)
      let weekEndDate = new Date(weekStartDate)
      weekEndDate.setDate(weekStartDate.getDate() + 6)
      weekEndDate.setHours(23, 59, 59, 999)

      if (inputDate >= weekStartDate && inputDate <= weekEndDate) {
        return `Tuần ${weekNumber} (${formatDate(weekStartDate)} - ${formatDate(
          weekEndDate
        )})`
      }

      currentWeekStart.setDate(currentWeekStart.getDate() + 7)
      weekNumber++

      if (currentWeekStart.getFullYear() > year) break
    }

    return 'Không tìm thấy tuần!'
  }
  const currentDate = new Date()
  const { currentUser } = authenticationStore
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear())
  const [selectedWeek, setSelectedWeek] = useState(getWeekOfDate(currentDate))
  const [workSchedulePersonalList, setWorkSchedulePersonalList] = useState([])
  const [isVisibleCreateModal, setIsVisibleCreateModal] = useState(false)
  const [isVisibleUpdateModal, setIsVisibleUpdateModal] = useState(false)
  const [workDetail, setWorkDetail] = useState({})
  const [isCreated, setIsCreated] = useState(false)
  const [isUpdated, setIsUpdated] = useState(false)

  useEffect(() => {
    let firstMonday = new Date(selectedYear, 0, 1)
    const weekNumber = parseInt(selectedWeek.match(/Tuần (\d+)/)[1], 10)
    while (firstMonday.getDay() !== 1) {
      firstMonday.setDate(firstMonday.getDate() - 1)
    }
    let weekStartDate = new Date(firstMonday)
    weekStartDate.setDate(weekStartDate.getDate() + (weekNumber - 1) * 7)
    setSelectedWeek(getWeekOfDate(weekStartDate))
  }, [selectedYear])

  const getWeeksOfYear = year => {
    const weeks = []
    let firstMonday = new Date(year, 0, 1)

    while (firstMonday.getDay() !== 1) {
      firstMonday.setDate(firstMonday.getDate() - 1)
    }

    let currentWeekStart = new Date(firstMonday)
    let weekNumber = 1

    for (let i = 0; i < 52; i++) {
      let weekStartDate = new Date(currentWeekStart)
      let weekEndDate = new Date(weekStartDate)
      weekEndDate.setDate(weekStartDate.getDate() + 6)

      weeks.push(
        `Tuần ${weekNumber} (${formatDate(weekStartDate)} - ${formatDate(
          weekEndDate
        )})`
      )

      currentWeekStart.setDate(currentWeekStart.getDate() + 7)
      weekNumber++
    }

    return weeks
  }

  const generateDateBetween = (start, end) => {
    const dates = []
    const [startDay, startMonth, startYear] = start.split('/').map(Number)
    const [endDay, endMonth, endYear] = end.split('/').map(Number)

    let currentDate = new Date(startYear, startMonth - 1, startDay)
    const endDate = new Date(endYear, endMonth - 1, endDay)

    while (currentDate <= endDate) {
      const day = String(currentDate.getDate()).padStart(2, '0')
      const month = String(currentDate.getMonth() + 1).padStart(2, '0')
      const year = currentDate.getFullYear()

      dates.push(`${year}-${month}-${day}`)
      currentDate.setDate(currentDate.getDate() + 1)
    }
    return dates
  }

  useEffect(() => {
    if (!selectedWeek) return
    const currentWeak = selectedWeek.match(/\((.*?)\)/)?.[1]
    const [startDate, endDate] = currentWeak.split(' - ')
    const featchData = async () => {
      const response = await WorkSchedulePersonalStore.getWorkSchedulePersonalList(
        startDate,
        endDate
      )

      const dateOfWeek = generateDateBetween(startDate, endDate)
      setWorkSchedulePersonalList(
        dateOfWeek.map(date => {
          const exitsDate = response.data.find(item => item.workDate === date)
          return (
            exitsDate || {
              workDate: date,
              morningWork: '',
              afternoonWork: '',
            }
          )
        })
      )
    }

    featchData()
  }, [selectedWeek, isCreated, isUpdated])

  const weekdays = [
    'Chủ nhật',
    'Thứ hai',
    'Thứ ba',
    'Thứ tư',
    'Thứ năm',
    'Thứ sáu',
    'Thứ bảy',
  ]

  const formatWorkDate = dateStr => {
    const [year, month, day] = dateStr.split('-')
    return `${day}/${month}/${year}`
  }
  const formatData = workSchedulePersonalList.flatMap((item, index) => {
    const date = new Date(item.workDate)
    const dayOfWeek = weekdays[date.getDay()]

    return [
      {
        key: `${index * 2 + 1}`,
        day: dayOfWeek,
        date: formatWorkDate(item.workDate),
        session: 'Sáng',
        work: item.morningWork || '',
        detail: item,
      },
      {
        key: `${index * 2 + 2}`,
        day: dayOfWeek,
        date: formatWorkDate(item.workDate),
        session: 'Chiều',
        work: item.afternoonWork || '',
      },
    ]
  })

  const generatedWeeks = useMemo(() => getWeeksOfYear(selectedYear), [
    selectedYear,
  ])

  const columns = [
    {
      title: 'Thời gian',
      align: 'center',
      children: [
        {
          render: (text, record, index) => {
            const obj = {
              children: `${record.day} ${record.date}`,
              props: { style: { backgroundColor: '#fff' } },
            }
            if (index % 2 === 0) {
              obj.props.rowSpan = 2
            } else {
              obj.props.rowSpan = 0
            }
            return obj
          },
          width: 100,
          align: 'center',
        },
        {
          dataIndex: 'session',
          key: 'session',
          align: 'center',
          width: 50,
        },
      ],
    },
    {
      title: 'Nội dung công việc',
      dataIndex: 'work',
      key: 'work',
      align: 'center',
      render: (text, record) => (
        <div
          contentEditable
          suppressContentEditableWarning
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'left',
            textAlign: 'left',
            minHeight: '40px',
            padding: '5px',
            outline: 'none',
            border: 'none',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
          onInput={(e) => handleWorkChange(record, e.currentTarget.innerText)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              document.execCommand('insertLineBreak');
            }
          }}
        >
          {text}
        </div>
      )
    },
  ]

  const [updatedData, setUpdatedData] = useState([]);

  useEffect(() => {
    if (workSchedulePersonalList.length > 0)
      setUpdatedData(formatData)
  }, [workSchedulePersonalList])

  const handleWorkChange = (record, newValue) => {
    setUpdatedData(pre => pre.map(item =>
      item.key === record.key ? { ...item, work: newValue } : item
    ))
  };

  const convertToWorkSchedule = (data) => {
    const result = [];

    data.forEach(({ date, session, work }) => {
      const workDate = date;

      let existingEntry = result.find(item => item.workDate === workDate);

      if (!existingEntry) {
        existingEntry = {
          workDate, morningWork: '', afternoonWork: '',
          assignedBy: currentUser.code,
          executedBy: currentUser.code,
          executedByDepartment: currentUser.department.code,
        };
        result.push(existingEntry);
      }

      if (session === 'Sáng') {
        existingEntry.morningWork = work;
      } else if (session === 'Chiều') {
        existingEntry.afternoonWork = work;
      }
    });

    return result;
  };

  const handleUpdate = async () => {
    try {
      setIsUpdated(false)
      await WorkSchedulePersonalStore.createOrUpdateWorkSchedulePersonal(
        convertToWorkSchedule(updatedData)
      )
      message.success('Chỉnh sửa lịch làm việc cá nhân thành công!')
      setIsUpdated(true)
    } catch (error) {
      message.error(error.vi || 'Đã có lỗi xảy ra!')
    }
  }

  return (
    <>
      <DashboardLayout title={'Lịch cá nhân'}>
        <Helmet>
          <title>Lịch cá nhân</title>
        </Helmet>
        <PageTitle
          location={props.location}
          title={'Lịch làm việc cá nhân'}
          hiddenGoBack>
          <div>
            <Button
              style={{ marginLeft: 15 }}
              onClick={handleUpdate}
              type={'primary'}>
              <EditOutlined />
              Cập nhật
            </Button>
          </div>
        </PageTitle>
        <div>
          <ContentBlockWrapper style={{ minHeight: 600 }}>
            <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
              <Select
                value={selectedWeek}
                onChange={setSelectedWeek}
                style={{ width: 300 }}
                placeholder="Ngày thực hiện">
                {generatedWeeks.map(week => (
                  <Option key={week} value={week}>
                    {week}
                  </Option>
                ))}
              </Select>
              <Select
                value={selectedYear}
                onChange={setSelectedYear}
                style={{ width: 120 }}>
                {[
                  ...Array(
                    currentDate.getFullYear() +
                    10 -
                    (currentDate.getFullYear() - 10) +
                    1
                  ),
                ].map((_, i) => {
                  const year = currentDate.getFullYear() - 10 + i
                  return (
                    <Option key={year} value={year.toString()}>
                      {year}
                    </Option>
                  )
                })}
              </Select>
            </div>

            {/* Bảng công việc */}
            <TableComponentCustorm>
              <TableComponent
                dataSource={formatData}
                columns={columns}
                pagination={false}
              />
            </TableComponentCustorm>
          </ContentBlockWrapper>
        </div>
      </DashboardLayout>
    </>
  )
}

export default memo(
  withRouter(inject('authenticationStore')(observer(WorkSchedulePersonal)))
)
